<template>
  <v-container
    class="mb-12"
  >
    <v-row
      align="center"
      justify="center"
      class="text-center mb-4"
    >
      <v-col>
        <v-icon x-large>
          mdi-gavel
        </v-icon>
        <h2 class="display-2">
          Impressum
        </h2>
      </v-col>
    </v-row>

    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        md="10"
        sm="10"
      >
        <v-card>
          <v-card-text>
            <p>Mein Impressum gilt für die Seite www.kegelmanager.de/www.kegelmanager.com sowie für die Kegelmanager-Seiten auf <a href="https://www.facebook.com/groups/kegelmanager">Facebook</a></p>
            <p class="headline">
              Verantwortlich für den Inhalt:
            </p>
            <p>Nico Grundmann<br> Julianenhof 11<br> 15377 Märkische Höhe </p>
            <p class="headline">
              Kontakt:
            </p>
            <p>
              Telefon: +49 (0) 30 99 29 69 36 4<br>
              E-Mail: webmaster&shy;@&shy;kegel&shy;manager&shy;.&shy;de
            </p>
            <v-divider class="mt-4 mb-4" />
            <p class="headline">
              Bilder
            </p>
            <p>Verwendete Bilder von https://pixabay.com sind unter Creative Commons CC0 als Public Domain bzw. als gemeinfrei veröffentlicht, weitere Bilder vom alten KMO und eigene Bilder</p>
            <v-divider class="mt-4 mb-4" />
            <p class="headline">
              Haftung f&uuml;r Links
            </p>
            <p>Unser Angebot enth&auml;lt Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb k&ouml;nnen wir f&uuml;r diese fremden Inhalte auch keine Gew&auml;hr &uuml;bernehmen. F&uuml;r die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf m&ouml;gliche Rechtsverst&ouml;&szlig;e &uuml;berpr&uuml;ft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.</p>
            <p>
              Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>
            <v-divider class="mt-4 mb-4" />
            <p class="headline">
              Haftung f&uuml;r Inhalte
            </p>
            <p>Als Diensteanbieter sind wir gem&auml;&szlig; &sect; 7 Abs.1 TMG f&uuml;r eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach &sect;&sect; 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, &uuml;bermittelte oder gespeicherte fremde Informationen zu &uuml;berwachen oder nach Umst&auml;nden zu forschen, die auf eine rechtswidrige T&auml;tigkeit hinweisen.</p>
            <p>
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unber&uuml;hrt. Eine diesbez&uuml;gliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung m&ouml;glich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>
            <v-divider class="mt-4 mb-4" />
            <p class="headline">
              Urheberrecht
            </p>
            <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielf&auml;ltigung, Bearbeitung, Verbreitung und jede Art der Verwertung au&szlig;erhalb der Grenzen des Urheberrechtes bed&uuml;rfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur f&uuml;r den privaten, nicht kommerziellen Gebrauch gestattet.</p>
            <p>
              Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </p>
            <v-divider class="mt-4 mb-4" />
            <p class="headline">
              WICHTIGER HINWEIS:
            </p>
            <p>Alle Spielernamen, die im Kegel Manager Online vorkommen, werden mittels eines Zufallgenerators erstellt. Dieser ermittelt die Namen aus ca. 2000 Vor- und 8000 Nachnamen. Demzufolge können sich hieraus keine Verletzungen von Persönlichkeits- oder Namensrechten ergeben.</p>
            <v-divider class="mt-4 mb-4" />
            <p>
              (Märkische Höhe, September 2018)
            </p>
            <v-divider class="mt-4 mb-4" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Impressum',
  metaInfo: {
    title: 'Impressum',
    meta: [
      { name: 'robots', content: 'noindex, follow' }
    ]
  }
}
</script>
